import { render, staticRenderFns } from "./passwd-set.vue?vue&type=template&id=81d3e12a&scoped=true&"
import script from "./passwd-set.vue?vue&type=script&lang=js&"
export * from "./passwd-set.vue?vue&type=script&lang=js&"
import style0 from "./passwd-set.vue?vue&type=style&index=0&id=81d3e12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d3e12a",
  null
  
)

export default component.exports